import React from "react";
import { BrowserRouter } from "react-router-dom";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import keycloak, { keycloakInitOptions } from "./Keycloak";
import { TimezoneProvider } from "./context/TimezoneContext";
import NewApp from "./NewApp";

function App() {
  return (
    <div className="min-h-screen bg-unlisted-very-light-gray">
      <ReactKeycloakProvider authClient={keycloak} initOptions={keycloakInitOptions}>
        <TimezoneProvider>
          <BrowserRouter>
            <NewApp />
          </BrowserRouter>
        </TimezoneProvider>
      </ReactKeycloakProvider>
    </div>
  );
}

export default App;
